import { makeStyles, tokens } from '@fluentui/react-components';
import { px } from '@this/app-shared/dist/tools/styles.js';

export const useStyles = makeStyles({
    fieldTable: {
        display: 'grid',
        position: 'relative',
        alignItems: 'start',
        gridColumn: '1 / -1',
    },
    preserveTableBottomPadding: {
        gridColumn: '1 / -1',
        position: 'relative',
        bottom: px(0),
        height: tokens.spacingHorizontalXXL,
        width: '100%',
        backgroundColor: tokens.colorTransparentBackground,
        pointerEvents: 'none',
        userSelect: 'none',
    },
});
